import { Tabs as TabList, Tab } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import useFirstSection from "../Hooks/useFirstSection";
import useTab from "../Hooks/useTab";
import { txt } from "../../../services/translation";
import useCourse from "../Hooks/useCourse";

export default function Tabs(){

    const {course: courseId} = useParams();
    const tab = useTab();
    const navigate = useNavigate();
    const firstSection = useFirstSection();
    const course = useCourse();


    const handleChange = v => {
        if(v === 'course'){
            return navigate(`/study/${courseId}/${firstSection()?.id}`);
        }
        return navigate(`/study/${courseId}/${v}`);
    }

    let tabs = {
        course: txt('courseTabShort'),
        docs: txt('docsTabShort'),
        notes: txt('notesTabShort'),
    };

    if(['dpc-pi','dpc','fifpl','standard','opco'].includes(course?.enrollment?.type?.id)){
        tabs.epp = 'EPP';
    }

    return <TabList 
        value={tab}
        onChange={(e,v) => handleChange(v)}
        variant="scrollable"
        scrollButtons={false}
    >
        {Object.keys(tabs).map(t => 
            <Tab label={tabs[t]} value={t} key={t} />    
        )}
    </TabList>

}